import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React from "react";
import secure from "../../images/payment-thumb.svg";

const SecurePayment = () => {
  return (
    <div className="secure-payment">
      <Container sx={{ py: 6 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 2, sm: 8, md: 12 }}
            sx={{
              alignItems: "center",
            }}
          >
            <Grid item xs={2} sm={4} md={6}>
              <Box>
                <img className="core-feature-img" src={secure} alt="" />
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={6}>
              <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
                <Typography className="sub-title" variant="subtitle1">
                  Core features
                </Typography>
                <Typography
                  sx={{
                    fontSize: 48,
                    mt: 2,
                    width: { xs: 1, md: "70%" },
                    mb: 2,
                  }}
                  className="section-title"
                  variant="h3"
                >
                  Secure Payment Transaction System with #1 Ranking
                </Typography>
                <Typography variant="body1">
                  Get your tests delivered at let home collect sample from the
                  victory of the managments that supplies best design system
                  guidelines ever. Get your tests delivered at let home collect
                  sample.
                </Typography>
                <Button sx={{ borderRadius: 50, my: 3 }} variant="contained">
                  Learn More
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default SecurePayment;
